export default {
  ErrorCode: {
    SEND_OTP_ERROR: 'Send OTP error',
    INVALID_TRADING_TOKEN: 'Invalid token',
    INVALID_OTP: 'The OTP is invalid',
    TIMEOUT: 'Time out',
    SYSTEM_ERROR: 'System error',
    DB_ACCESS_ERROR: 'System error',
    EOD_ERROR: 'EOD error ',
    RESOURCE_NOT_FOUND: 'Cannot find this resource',
    NPUT_MISSING: 'Input is required',
    ACCOUNT_MISSIN: 'No matched account',
    TICKER_MISSING: 'No matched ticker',
    ORDER_TYPE_INVALID: 'Invalid order type',
    INPUT_FORMAT_INVALID: 'Invalid input format',
    INPUT_INVALID: 'Invalid input',
    STOCK_PRICE_UNDEFINED: 'Cannot find stock price',
    MARKET_SESSION_UNDEFINED: 'Cannot determine market session',
    ORDER_STATUS_REJECTED: 'Cannot execute that action on current order status',
    CAN_NOT_REPLACE_PLO_ORDER: 'Cannot replace PLO order',
    CAN_NOT_CANCEL_ATO_ORDER: 'Cannot cancel ATO order',
    CAN_NOT_CANCEL_MARKET_ORDER: 'Cannot cancel  order',
    CAN_NOT_CANCEL_THAT_ORDER_ON_THIS_SESSION:
      'Cannot cancel that order on this session',
    CAN_NOT_PLACE_ORDER_WITH_QUANTITY_GREATER_THAN_CURRENT_ROOM:
      'Cannot place order with volume greater than current room',
    REMOTE_ACCESS_ERROR: 'System error',
    CAN_NOT_PLACE_PLO_ORDER_WITHOUT_MATCHED:
      'Cannot place PLO order if has no matched',
    CAN_NOT_CANCEL_PENDINGNEW_ORDER_IN_OPEN_SESSION:
      'Cannot cancel " Pending New "order in Open session',
    INVALID_SECURITY_TYPE: 'Invalid security type',
    CAN_NOT_PLACE_ORDER_ON_HALTED_TICKER:
      'Cannot place order on halted security',
    CAN_NOT_PLACE_ORDER_ON_UNLISTED_TICKER:
      'Cannot place order on unlisted security',
    CAN_NOT_PLACE_ORDER_ON_SUSPENDED_TICKER:
      'Cannot place order on suspended security',
    CAN_NOT_PLACE_ODD_LOT_ORDER_ON_SPECIAL_TICKER: 'Cannot place odd lot order',
    CAN_NOT_PLACE_ORDER_WITH_THIS_TICKER_TYPE:
      'Cannot place order with this security type',
    CAN_NOT_PLACE_ORDER_WITH_THAT_ORDER_TYPE_ON_INTERMISSION_SESSION:
      'Cannot place order with that order type on intermission session',
    CANNOT_PLACE_OPPOSITE_ORDER_IN_THIS_SESSION:
      'Cannot place opposite order in this session',
    CANNOT_PLACE_OPPOSITE_ORDER: 'Cannot place opposite order',
    CANNOT_PLACE_CROSS_ORDER_ON_THAT_SESSION:
      'Cannot place cross order on that session',
    CANNOT_PLACE_ADV_ORDER_ON_THIS_SESSION:
      'Cannot place adv order on this session',
    CANNOT_PLACE_CROSS_ORDER_ON_SPECIAL_TICKER:
      'Cannot place cross order on special security',
    CANNOT_PLACE_ADV_ORDER_ON_SPECIAL_TICKER:
      'Cannot place adv order on special security',
    CANNOT_PLACE_ADV_ORDER_ON_HALT_TICKER:
      'Cannot place adv order on halt security',
    CANNOT_PLACE_ADV_ORDER_ON_SUSPENDED_TICKER:
      'Cannot place adv order on suspended security',
    CANNOT_PLACE_ADV_ORDER_ON_UNLISTED_TICKER:
      'Cannot place adv order on unlisted security',
    CANNOT_CANCEL_CROSS_ORDER_ON_THAT_SESSION_AND_STATUS:
      'Cannot cancel cross order on that session and status',
    CANNOT_CONFIRM_OR_REJECT_CROSS_ORDER_ON_THAT_ORDER_STATUS:
      'Cannot confirm or reject cross order on that order status',
    CANNOT_CONFIRM_OR_REJECT_CROSS_ORDER_ON_THIS_SESSION:
      'Cannot confirm or reject cross order on this session',
    REJECTED_BY_BUY_SIDE: 'Rejected by Buy Side',
    MISSING_BUY_CUSTODY: 'Please check the Buy side custody',
    MISSING_BUY_ACCOUNT: 'Please check the Buy side account',
    MISSING_BUY_FIRM_ID: 'Please check the Buy side ID',
    MISSING_BUY_TRADER_ID: 'Please check the Buy trader ID',
    TICKER_IS_NOT_IN_MARGIN_BASKET: 'Ticker is not in margin basket',
    MISSING_ADV_CONTACT: 'Please check the contact',
    MISSING_CONTRA_FIRM_ID: 'Please check contra firm ID',
    MISSING_CONTRA_TRADER_ID: 'Please check contact trader ID',
    CANNOT_CANCEL_ADV_ORDER_WITH_THIS_STATUS:
      'cancel adv order with this status',
    CANNOT_CANCEL_ADV_ORDER_FROM_OTHER_FIRM:
      'Cannot cancel adv order from other firm',
    INVALID_ADV_ORDER_ID: 'Invalid adv order ID',
    QUANTITY_NOT_MATCH_WITH_ADV_ORDER:
      "Volume is not equal with adv order's quantity",
    TICKER_NOT_MATCH_WITH_ADV_ORDER:
      "Ticker is not equal with adv order's ticker",
    CANNOT_CANCEL_ADV_ORDER_ON_THIS_SESSION:
      'Cannot cancel adv order in this session',
    CANNOT_PLACE_MANY_CROSS_ORDER_ON_A_ADV_ORDER:
      'Không để đặt nhiều lệnh thoả thuận trên 1 lệnh quảng cáo',
    CANNOT_PLACE_CROSS_ORDER_ON_THIS_ADV_ORDER_STATUS:
      'Cannot place cross orders on this adv order status',
    INVALID_BUY_FIRM_ID: 'Invalid buy Firm ID',
    CANNOT_PLACE_ONE_FIRM_CROSS_ORDER_ON_ADV_ORDER_FROM_OTHER_SIDE:
      'Cannot place one firm cross order on Adv order from the other side',
    CANNOT_PLACE_ONE_FIRM_CROSS_ORDER_ON_ADV_ORDER_FROM_OUR_SIDE:
      'Cannot place two firm cross orders on Buy Adv order from our side',
    CANNOT_PLACE_CROSS_ORDER_ON_SELL_ADV_ORDER_FROM_OTHER_SIDE:
      'Cannot place cross orders on sell adv order from the other side',
    CANNOT_PLACE_CROSS_ORDER_ON_UNKNOWN_ADV_ORDER:
      'Cannot place cross order on unknown adv order',
    INTERNAL_COMPARE_ERROR: 'Internal compare error',
    EXTERNAL_COMPARE_ERROR: 'External compare error',
    INVALID_INTERNAL_COMPARE_STATUS: 'Invalid internal compare status',
    INVALID_EXTERNAL_COMPARE_STATUS: 'Invalid internal compare status',
    VIOLATE_POOL_RULE: 'Violate pool rule',
    PP0_EXCEED: 'PPSE exceed',
    INVALID_VALIDATION_REPORT: 'System error',
    CUSTODY_INVALID: 'Invalid custody code',
    REQ_TIMEOUT: 'This action is not allowed',
    INVALID_INPUT: 'Invalid Input',
    REMOTE_SERVER_ERROR: 'System error',
    THIRD_PARTY_ERROR: 'System error',
    RESOURCE_NOT_FOUND: 'System error',
    FSS_EXCEPTION: 'System error',
    INVALID_ORDER_QUANTITY: 'Invalid order quantity',
    INVALID_ORDER_PRICE: 'Invalid order price',
    INVALID_OTP: 'Invalid OTP',
    INVALID_TRADING_TOKEN: 'Invalid token',
    METHOD_NOT_ALLOWED: 'System error',
    MISSING_PATH_VARIABLE: 'System error',
    CONFLICT_REQUEST_ID: 'System error',
    STOCK_NOT_ENOUGH: 'Not enough stock',
    INVALID_PRICE: 'Invalid price',
    INVALID_ORDER_TYPE: 'Invalid order type',
    PURCHASING_POWER_NOT_ENOUGH: 'PPSE exceed',
    INVALID_ORDER_ID: 'Invalid order ID',
    INVALID_ORDER_STATE: 'Invalid order state',
    OUT_OF_MARGIN_BASKET: 'Securities is not in margin basket',
    VSD_INACTIVE: 'System error',
    INVALID_TRADING_SESSION: 'Invalid trading session',
    BATCH_IN_PROGRESS: 'System error',
    INVALID_SUBACCOUNT_STATUS: 'Sub account is not active',
    PENDING_REVERSE_ORDER: 'Can not place order because reverse order',
    TRADING_SESSION_NOT_ALLOW_CANCEL: 'Not allow cancel order in this session',
    SYMBOL_NOT_EXIST: 'Stock not found',
    TRADING_HALT: 'Stock is halt',
    CW_TRADING_NOT_ALLOWED__ON_MARGIN_ACCOUNT:
      'Margin account is not allow trade CW',
    EXPIRED_CW: 'CW is expired',
    VIOLATE_POOL_ROOM: 'Not enough room',
    PLACE_ORDER_NOT_ALLOW: 'System not allow place order',
    CANCEL_ORDER_NOT_ALLOW: 'System not allow cancel order',

    PRICE_MUST_LESS_THAN_OR_EQUAL_TO_CEILING_PRICE:
      'Price must be less than or equal to ceiling price',
    PRICE_MUST_GREATER_THAN_OR_EQUAL_TO_FLOOR_PRICE:
      'Price must be greater than or equal to floor price',
    INVALID_PRICE_LOT: 'Invalid price',
    INVALID_QUANTITY: 'Invalid quantity',
    INVALID_QUANTITY_LOT: 'Invalid quantity',
    INVALID_ORDER_SIDE: 'Invalid order side',
    CAN_NOT_PLACE_ORDER_ON_THIS_SESSION: 'Cannot place order on this session',
    CAN_NOT_PLACE_ORDER_WITH_THAT_ORDER_TYPE_ON_ATO_SESSION:
      'Cannot place order with that order type on ATO session',
    CAN_NOT_PLACE_ORDER_WITH_THAT_ORDER_TYPE_ON_ATC_SESSION:
      'Cannot place order with that order type on ATC session',
    CAN_NOT_PLACE_ORDER_WITH_THAT_ORDER_TYPE_ON_OPEN_SESSION:
      'Cannot place order with that order type on OPEN session',
    CAN_NOT_PLACE_ORDER_WITH_THAT_ORDER_TYPE_ON_RUN_OFF_SESSION:
      'Cannot place order with that order type on RUN OFF session',
    CAN_NOT_PLACE_ORDER_WITH_THAT_ORDER_TYPE_ON_BEGIN_OF_DAY_SESSION:
      'Cannot place order with that order type on BEGIN OF DAY session',
    CAN_NOT_REPLACE_THAT_ORDER_ON_THIS_SESSION:
      'Cannot replace order on this session',
    INVALID_SYMBOL: 'No data',
    INVALID_PRICE: 'Invalid price',
  },
};
